import React from 'react';
import PropTypes from 'prop-types';
import { isFunctionComponent } from 'utils/helpers';
import BWButton from '../BWButton';
import BWModal from '../BWModal';

const Modal = ({
  children,
  open,
  onClose,
  header,
  footer,
  witdh,
  lalbelClose,
  className,
}) => {
  const resolvedHeader = isFunctionComponent(header) ? React.createElement(header) : header;
  const footerActions = (
    <div className='bw_modal_ds_actions'>
      {footer}
      <BWButton type='primary' outline content={lalbelClose ?? 'Quay về'} onClick={onClose} />
    </div>
  );

  return (
    <BWModal
      open={open}
      title={resolvedHeader || 'Thông báo'}
      width={witdh}
      modalClassName={className}
      footer={footerActions}
      maskClosable={false}
      onClose={onClose}>
      {children}
    </BWModal>
  );
};
Modal.propTypes = {
  open: PropTypes.bool,
  className: PropTypes.string,
  header: PropTypes.node,
  footer: PropTypes.node,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  children: PropTypes.node,
  witdh: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  lalbelClose: PropTypes.string,
};

export default Modal;
